<template>
<iframe :src="pdfSrcProp"></iframe>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";

export default defineComponent({
    name: "PDFViewer",
    props: {
        pdfSrcProp: {
            type: String,
            required: true
        }
    },
})
</script>

<style scoped lang="scss">
iframe {
    border: none;
}
</style>